import React, { useRef, useEffect, useState } from "react";
import styles from "../styles_home/WhyChooseUs.module.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const REASONS_DATA = [
  { title: "Expertise & Experience", description: "With years of experience, we bring unmatched expertise to every project.", icon: "🎓", color: "#4F46E5" },
  { title: "Tailored Solutions", description: "We provide customized strategies that align with your unique business needs.", icon: "🔧", color: "#06B6D4" },
  { title: "Proven Results", description: "Our work speaks for itself with measurable outcomes and tangible success.", icon: "📈", color: "#10B981" },
  { title: "Innovative Approach", description: "We use the latest technologies and methods to drive your business forward.", icon: "💡", color: "#F59E0B" },
  { title: "Dedicated Support", description: "Our team is always available to assist you and ensure your success.", icon: "🤝", color: "#EC4899" },
  { title: "Customer-Centric", description: "Your satisfaction is our priority; we focus on delivering value at every step.", icon: "❤️", color: "#EF4444" }
];

const ReasonCard = ({ reason }) => (
  <div className={styles.reasonCard} style={{ "--card-color": reason.color }}>
    <div className={styles.iconWrapper}>
      <span className={styles.icon}>{reason.icon}</span>
    </div>
    <h3 className={styles.cardTitle}>{reason.title}</h3>
    <p className={styles.cardDescription}>{reason.description}</p>
    <button className={styles.btn}>Learn More</button>
  </div>
);

const WhyChooseUs = () => {
  const sliderRef = useRef(null);
  const [autoPlay, setAutoPlay] = useState(true);
  const [isLaptopScreen, setIsLaptopScreen] = useState(window.innerWidth > 1024);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsLaptopScreen(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-slide effect for laptop screens
  useEffect(() => {
    let interval;
    if (autoPlay && isLaptopScreen) {
      interval = setInterval(() => {
        if (sliderRef.current) {
          const nextIndex = (currentIndex + 1) % REASONS_DATA.length;
          setCurrentIndex(nextIndex);
          const scrollAmount = nextIndex * 350;
          sliderRef.current.scrollTo({ left: scrollAmount, behavior: "smooth" });
        }
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [autoPlay, currentIndex, isLaptopScreen]);

  const scrollLeft = () => {
    setAutoPlay(false);
    const nextIndex = (currentIndex - 1 + REASONS_DATA.length) % REASONS_DATA.length;
    setCurrentIndex(nextIndex);
    const scrollAmount = nextIndex * 350;
    sliderRef.current.scrollTo({ left: scrollAmount, behavior: "smooth" });
  };

  const scrollRight = () => {
    setAutoPlay(false);
    const nextIndex = (currentIndex + 1) % REASONS_DATA.length;
    setCurrentIndex(nextIndex);
    const scrollAmount = nextIndex * 350;
    sliderRef.current.scrollTo({ left: scrollAmount, behavior: "smooth" });
  };

  // Handle scroll end
  useEffect(() => {
    const handleScrollEnd = () => {
      if (sliderRef.current) {
        const scrollPosition = sliderRef.current.scrollLeft;
        const newIndex = Math.round(scrollPosition / 350);
        setCurrentIndex(newIndex % REASONS_DATA.length);
      }
    };

    const slider = sliderRef.current;
    if (slider) {
      slider.addEventListener('scrollend', handleScrollEnd);
      return () => slider.removeEventListener('scrollend', handleScrollEnd);
    }
  }, []);

  return (
    <section className={styles.sectionContainer}>
      <div className={styles.headerContent}>
        <h2 className={styles.sectionTitle}>Why Choose Us?</h2>
        <p className={styles.sectionSubtitle}>
          Discover the unique advantages that set us apart.
        </p>
      </div>

      <div className={styles.sliderContainer}>
        <div 
          className={styles.sliderWrapper} 
          ref={sliderRef}
          onMouseEnter={() => isLaptopScreen && setAutoPlay(false)}
          onMouseLeave={() => isLaptopScreen && setAutoPlay(true)}
        >
          {REASONS_DATA.map((reason, index) => (
            <ReasonCard key={index} reason={reason} />
          ))}
        </div>
      </div>

      <div className={styles.arrowContainer}>
        <button className={styles.arrowButton} onClick={scrollLeft}>
          <FaArrowLeft />
        </button>
        <button className={styles.arrowButton} onClick={scrollRight}>
          <FaArrowRight />
        </button>
      </div>

      <div className={styles.indicators}>
        {REASONS_DATA.map((_, index) => (
          <button
            key={index}
            className={`${styles.indicator} ${index === currentIndex ? styles.activeIndicator : ''}`}
            onClick={() => {
              setAutoPlay(false);
              setCurrentIndex(index);
              sliderRef.current.scrollTo({ left: index * 350, behavior: "smooth" });
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
